import { FlexRow } from '@/components/common/Flex';
import { Bank } from '@/components/common/icons';
import { Text } from '@/components/common/Typography';
import {
    useDepositoryAccount,
    useGoalFromGoalAccountId,
} from '@common/react/goals';
import AccountLockup from '../financialEntities/AccountLockup';
import GoalLockup from './GoalLockup';

interface TransactionSourceOrDestinationLockupProps {
    financialEntityId: string;
}

const TransactionSourceOrDestinationLockup = ({
    financialEntityId,
}: TransactionSourceOrDestinationLockupProps) => {
    const depositoryAccount = useDepositoryAccount(financialEntityId);
    const goal = useGoalFromGoalAccountId(financialEntityId);
    return depositoryAccount ? (
        <AccountLockup account={depositoryAccount} />
    ) : goal ? (
        <GoalLockup goal={goal} withPlentyPrefix />
    ) : (
        <FlexRow mt={0.5}>
            <Bank />
            <FlexRow ml={4}>
                <Text>Private or deleted account</Text>
            </FlexRow>
        </FlexRow>
    );
};

export default TransactionSourceOrDestinationLockup;
